
export interface SalesPartnerPaymentModel {
  id: number;
  date: string;
  paymentMethod: number;
  spBankAccountId: number;
  amount: number;
  paidById: number;
  paidByName: string;
  receivedById: number;
  receivedByName: string;
  voucherNumber: string;
  note: string;
  salesPartnerId: number;
}

export const SalesPartnerPaymentModelData: SalesPartnerPaymentModel = {
  id: 0,
  date: '',
  paymentMethod: 0,
  spBankAccountId: 0,
  amount: 0,
  paidById: 0,
  paidByName: '',
  receivedById: 0,
  receivedByName: '',
  voucherNumber: '',
  note: '',
  salesPartnerId: 0
};
